import { Nullable } from "../../base-types";
import Guard from "../../guard";
import { IIterator } from "./iterator";
import { Query } from "./query";
import { IQueryResult } from "./query-result";
import { QueryResultPagingManager } from "./query-result-paging-manager";

export interface IQueryIterator<T extends IQueryResult> extends IIterator<T> {
    readonly current: Nullable<T>;
}

export abstract class QueryIteratorBase<T extends IQueryResult> implements IQueryIterator<T> {
    private readonly _query: Query;
    current: Nullable<T>;

    constructor(query: Query, result?: T) {
        Guard.notNullOrUndefined(query);

        this._query = query; //TODO deep copy

        if (result != null) {
            this.current = result;
        }
    }

    canMoveNext(): boolean {
        return QueryResultPagingManager.canMoveNext(this.current);
    }

    canMovePrevious(): boolean {
        return QueryResultPagingManager.canMovePrevious(this.current);
    }

    async moveNextAsync(): Promise<boolean> {
        if (!this.canMoveNext()) return false;

        this._query.skip = QueryResultPagingManager.getOffsetNextPage(this.current);
        this.current = await this.getResultAsync(this._query);

        return true;
    }

    async movePreviousAsync(): Promise<boolean> {
        if (!this.canMovePrevious()) return false;

        this._query.skip = QueryResultPagingManager.getOffsetPreviousPage(this.current);
        this.current = await this.getResultAsync(this._query);

        return true;
    }

    reset(): void {
        this.current = null;
    }

    abstract getResultAsync(query: Query): Promise<T>;
}
